import { FormGroup, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import type { FormEvent } from 'react';
import { post, put } from 'helpers/api';
import ErrorAlert from '../../../project/components/new_listing_modal/error_alert';
import Button from 'shared/button';
import { getChildCompanyIdFromUrl } from '../shared';

type EditModalProps = {
  id: string | number;
  isRole?: boolean;
  name?: string;
  onCloseModal: () => void;
  onSuccessfulFormSubmit: (result: any) => void;
};

export default function EditModal(props: EditModalProps) {
  const [inputName, setInputName] = useState<string>(props.name || '');
  const [inputIsRole, setInputIsRole] = useState<boolean>(props.isRole || false);
  const [errors, setErrors] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const canSubmitForm = inputName.length > 0;

  async function submitForm(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!canSubmitForm) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    const { fetchMethod, url } = fetchParams();
    try {
      const departmentArguments = { name: inputName, is_role: inputIsRole };
      const res = await fetchMethod(url, { company_department: departmentArguments });
      setIsSubmitting(false);
      if (res.id) {
        props.onSuccessfulFormSubmit(res);
      } else {
        setErrors(res);
      }
    } catch {
      setIsSubmitting(false);
      const uploadType = props.id === '' ? 'created' : 'updated';
      setErrors([`Department or Role could not be ${uploadType}. Please try again or contact support for help.`]);
    }
  }

  function fetchParams() {
    const childCompanyId = getChildCompanyIdFromUrl();
    const urlSuffix = childCompanyId ? `?child_company_id=${childCompanyId}` : '';

    if (props.id === '') {
      return { fetchMethod: post, url: `/company_departments${urlSuffix}` };
    }
    return { fetchMethod: put, url: `/company_departments/${props.id}${urlSuffix}` };
  }

  return (
    <Modal.Body className="p-5">
      <h2 className="text-center mt-0 mb-4">{props.id === '' ? 'Add a' : 'Edit'} Department or Role</h2>
      <ErrorAlert errorMessages={errors} hasErrors={errors.length > 0}/>
      <form onSubmit={submitForm}>
        <FormGroup>
          <label htmlFor="department-name">Add Department or Role Name</label>
          <input
            autoFocus
            className="form-control"
            id="department-name"
            placeholder="Enter department or role name"
            value={inputName}
            onChange={e => setInputName(e.target.value)}
          />
        </FormGroup>
        
        { props.id === '' && (
          <FormGroup className="d-flex align-items-center gap-2">
            <input
              checked={inputIsRole}
              className="m-0"
              id="department-role"
              type="checkbox"
              onChange={e => setInputIsRole(e.target.checked)}
            />
            <label className="m-0" htmlFor="department-role" style={{ lineHeight: '1' }}>Role?</label>
          </FormGroup>
        )}
        
        <div className="mt-5 d-flex gap-3">
          <Button.Cancel
            disabled={isSubmitting}
            type="button"
            onClick={props.onCloseModal}
          >
            Cancel
          </Button.Cancel>
          <Button.Primary disabled={!canSubmitForm || isSubmitting} type="submit">
            {props.id === '' ? 'Add' : 'Update'} Department or Role
          </Button.Primary>
        </div>
      </form>
    </Modal.Body>
  );
}